<template>
  <div class="app-main-inner">
    <div class="app-main-inner-tab">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('Information.PartnerInformationImport')" name="first">
          <el-form
            :inline="true"
            label-width="150px"
            label-position="left"
            style="width: 1000px;padding-left: 100px;padding-top: 50px;"
          >
            <div class="el-form-item-wrapper">
              <fieldset style="padding-top: 10px;">
                <legend>{{ $t('Information.DownloadTemplate') }}</legend>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Information.PleaseSelectTemplateType')">
                    <el-radio v-if="isZY" v-model="downloadTempalteType" label="PartnerBasicInformationZy">{{ $t('Information.PartnerBasicInformation') }}</el-radio>
                    <el-radio v-else v-model="downloadTempalteType" label="PartnerBasicInformation">{{ $t('Information.PartnerBasicInformation') }}</el-radio>
                    <el-radio v-model="downloadTempalteType" label="PartnerInvoiceTitleInformation">{{ $t('Information.PartnerBillingHeaderInformation') }}</el-radio>
                  </el-form-item>
                  <el-form-item style="padding-left: 50px;">
                    <el-button type="primary" @click="downLoadTemplate">{{ $t('Information.Download') }}</el-button>
                  </el-form-item>
                </div>
              </fieldset>

            </div>
            <div class="el-form-item-wrapper" style="padding-top: 30px;">
              <fieldset style="padding-top: 10px;">
                <legend>{{ $t('Information.ImportFile') }}</legend>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Information.PleaseSelectImportType')">
                    <el-radio v-if="isZY" v-model="uploadContent.type" label="PartnerBasicInformationZy">{{ $t('Information.PartnerBasicInformation') }}</el-radio>
                    <el-radio v-else v-model="uploadContent.type" label="PartnerBasicInformation">{{ $t('Information.PartnerBasicInformation') }}</el-radio>
                    <el-radio v-model="uploadContent.type" label="PartnerInvoiceTitleInformation">{{ $t('Information.PartnerBillingHeaderInformation') }}</el-radio>
                  </el-form-item>
                  <el-form-item label="文件名：" style="padding-top: 30px;">
                    <el-input v-model="uploadContent.fileName" :disabled="true" style="width: 300px;" />
                    <el-upload
                      ref="upload"
                      style="padding-top: 30px;"
                      class="upload-demo"
                      :multiple="false"
                      :show-file-list="false"
                      :file-list="fileList"
                      :auto-upload="false"
                      :on-change="handleChange"
                      :action="url.mdm.partnerInformationImport.importPartnerInformation"
                      :headers="{sessionId:currentSessionId}"
                      :data="uploadContent"
                      accept=".xls,.xlsx"
                      :before-upload="beforeUpload"
                      :on-success="uploadSuccess"
                      :on-error="uploadExcelError"
                    >
                      <el-button slot="trigger" size="small" type="primary">{{ $t('Information.SelectFile') }}</el-button>
                      <el-button style="margin-left: 20px;" size="small" type="success" @click="submitUpload">{{ $t('Information.ConfirmImport') }}</el-button>
                      <div slot="tip" class="el-upload__tip" style="padding-top: 10px;color: orange">{{ $t('Information.ReminderPartnerBasicInformationFirst') }}</div>
                    </el-upload>
                  </el-form-item>
                </div>
              </fieldset>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.historyLogQuery')" name="second">
          <div class="app-main-inner" type="primary">
            <div class="app-main-page" style="height: calc(100vh - 150px)">
              <div class="app-main-inner-row">
                <div class="triggers">
                  <el-button size="mini" type="primary" @click="toQuery">{{ $t('Information.Search') }}</el-button>
                  <cargo-grid-state-btn :grid-params="gridParams" config-module="101341" />
                </div>
              </div>
              <div class="app-main-inner-row">
                <el-form :inline="true" label-width="70px" label-position="left" @submit.native.prevent>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Information.ImportTime')">
                      <div class="block">
                        <el-date-picker
                          v-model="searchConditions.startDate"
                          value-format="yyyy-MM-dd"
                          type="date"
                          :placeholder="$t('Information.SelectDate')"
                        />
                        <span class="demonstration">{{ $t('Information.To') }}</span>
                        <el-date-picker
                          v-model="searchConditions.endDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :placeholder="$t('Information.SelectDate')"
                        />
                      </div>
                    </el-form-item>
                    <el-form-item :label="$t('Information.ImportResult')">
                      <el-select v-model="searchConditions.importResult" :placeholder="$t('Information.PleaseSelect')">
                        <el-option
                          v-for="item in importResultOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Information.ImportType')">
                      <el-select v-model="searchConditions.importType" :placeholder="$t('Information.PleaseSelect')">
                        <el-option
                          v-for="item in importTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <div class="app-main-inner-row row-grid" style="margin-left:6px;margin-right:20px;display:flex;min-height:420px">
                <cargo-ag-grid
                  config-module="101341"
                  :grid-params.sync="gridParams"
                  :grid-options="gridOptions"
                  :column-defs="columnDefs"
                  :row-data="rowData"
                />
              </div>
              <div class="app-main-inner-row row-pagination">
                <cargo-pagination
                  :total="searchConditions.total"
                  :page.sync="searchConditions.pageNum"
                  :limit.sync="searchConditions.pageSize"
                  @pagination="fetchPartnerInformationImport"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 弹出框 -->
      <el-dialog :title="$t('Information.ImportSuccessful')" :visible.sync="dialogFormVisible" :show-close="false" width="500px">
        <el-form :model="importResult">
          <el-form-item style="text-align: center">
            <span style="font-size: larger">{{ $t('Pricing.XSuccessfulXFailed', [importResult.successCount, importResult.errorCount]) }}</span>
          </el-form-item>
          <el-form-item style="padding-top: 20px;text-align: center">
            <el-button type="primary" @click="continueImporting">{{ $t('Information.ContinueImport') }}</el-button>
            <el-button @click="enterPartner">{{ $t('Information.EnterPartnerInformation') }}</el-button>
          </el-form-item>
          <el-form-item style="padding-top: 20px;padding-left: 340px;">
            <el-link :href="importResult.downloadResultUrl" target="_blank" style="color: blue;text-decoration:underline">{{ $t('Information.DownloadImportResult') }}</el-link>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import {
  queryImportRecord
} from '@/api/partnerInformationImport'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'PartnerInformationImport',
  components: { cargoAdvanceSelect },
  data() {
    return {
      TYPE_NAMES,
      storageURL: '',
      activeName: 'first',
      fullscreenLoading: null,
      isZY: false,
      currentSessionId: getToken(),
      searchConditions: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
        startDate: '',
        endDate: '',
        importResult: '',
        importType: '1'
      },
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('Information.SerialNumber'),
          field: 'importNo',
          width: 300
        },
        {
          headerName: this.$t('Information.ImportTime'),
          field: 'dateCreated',
          width: 300
        },
        {
          headerName: this.$t('Information.Operator'),
          field: 'createdBy',
          width: 300,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Information.ImportFile'),
          width: 300,
          cellRenderer: params => {
            return `<a href="${URL.common.findByFileId}/${params.data.importFile || 'null'}?sessionId=${this.currentSessionId}" target="_blank" style="color:#46a6ff">查看文件</a>`
          }
        },
        {
          headerName: this.$t('Information.LogFile'),
          width: 300,
          cellRenderer: params => {
            return `<a href="${URL.common.findByFileId}/${params.data.resultFile || 'null'}?sessionId=${this.currentSessionId}" target="_blank" style="color:#46a6ff">查看文件</a>`
          }
        },
        {
          headerName: this.$t('Information.RemarkDescription'),
          field: 'remark',
          width: 300
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      importResultOptions: [{
        value: '1',
        label: this.$t('Information.AllSuccessful')
      }, {
        value: '2',
        label: this.$t('Information.AllFailed')
      }, {
        value: '3',
        label: this.$t('Information.PartiallySuccessfulPartiallyFailed')
      }],
      importTypeOptions: [{
        value: '1',
        label: this.$t('Information.PartnerBasicInformation')
      }, {
        value: '2',
        label: this.$t('Information.PartnerBillingHeaderInformation')
      }],
      fileList: [],
      uploadContent: {
        type: 'PartnerBasicInformation',
        fileName: ''
      },
      downloadTempalteType: 'PartnerBasicInformation',
      dialogFormVisible: false,
      importResult: {
        successCount: 0,
        errorCount: 0,
        downloadResultUrl: ''
      }
    }
  },
  computed: {
    url() {
      return URL
    }
  },
  async created() {
    await this.initData()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.CONFIG)
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.storageURL = cache.config.get('StorageURL')
      if (this.isZY) {
        this.downloadTempalteType = 'PartnerBasicInformationZy'
        this.uploadContent.type = 'PartnerBasicInformationZy'
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    toQuery() {
      this.fetchPartnerInformationImport()
    },
    fetchPartnerInformationImport() {
      this.fullscreenLoading = getLoading()
      queryImportRecord(this.searchConditions).then(res => {
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.rowData = res.data.list
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleChange(file, fileList) {
      this.uploadContent.fileName = file.name
      this.fileList = [file]
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('Information.TheOnlyBeXlsFormat'),
          type: 'warning'
        })
      }
      return extension || extension2
    },
    downLoadTemplate() {
      window.open(URL.mdm.partnerInformationImport.downLoadTemplate + '?sessionId=' + getToken() + '&type=' + this.downloadTempalteType)
    },
    uploadSuccess(response, file, fileList) {
      this.$nextTick(() => {
        this.fileList = []
        this.uploadContent.fileName = ''
      })
      if (response && response.data) {
        this.importResult.successCount = response.data.successCount
        this.importResult.errorCount = response.data.errorCount
        const cloudId = (response.data.importResultCloudId === null || response.data.importResultCloudId === '') ? 'null' : response.data.importResultCloudId
        this.importResult.downloadResultUrl = URL.common.findByFileId + '/' + cloudId + '?sessionId=' + this.currentSessionId
        console.log('downloadResultUrl-------------------', this.importResult.downloadResultUrl)
        this.dialogFormVisible = true
      } else {
        this.$message({
          message: response.message,
          type: 'error'
        })
      }
    },
    uploadExcelError() {
      this.$nextTick(() => {
        this.fileList = []
        this.uploadContent.fileName = ''
      })
    },
    continueImporting() {
      this.dialogFormVisible = false
      this.uploadContent.fileName = ''
    },
    enterPartner() {
      this.dialogFormVisible = false
      this.$router.push({ name: 'Partner' })
    }
  }
}
</script>

<style scoped>

</style>
